import moment from 'moment/moment';
import {
  getLicenseKeyByLicenseId,
  getPreviewPeriodFromProductCode,
  groupSubscriptionsByOwner,
  groupSubscriptionsByOwnerAndLicenseId,
} from './utils';
import { makeCapacities } from 'reactApp';

export default function (app) {
  app.controller('klCustomerCenterSubscriptionCtrl', [
    '$state',
    '$http',
    '$timeout',
    'klAccountService',
    'klConfigService',
    function ($state, $http, $timeout, AccountService, ConfigService) {
      this.isLoading = true;
      this._config = null;
      this._capacities = null;

      this.isReseller = function () {
        return AccountService.isReseller();
      };

      this.hasSubscriptions = function () {
        return !!this.subscriptions && this.subscriptions.length > 0;
      };

      this.showRatePlan = (ratePlan) => this._capacities.ratePlan(ratePlan).canBeDisplayed();

      const NO_SUBSCRIPTION_ERROR = 'No subscription provided to the ratePlansToUse function.';
      const NO_RATE_PLANS_ERROR =
        'No rate plans found in the subscription provided to the ratePlansToUse function.';

      this.ratePlansToUse = function (subscription) {
        if (!subscription) {
          console.error(NO_SUBSCRIPTION_ERROR);
          return [];
        }

        if (!subscription.ratePlans) {
          console.error(NO_RATE_PLANS_ERROR);
          return [];
        }
        return subscription.mergedNonDiscountRatePlans || subscription.ratePlans;
      };

      this.canDisplayUsage = (accountId, licenseId) => {
        const license = this.subscriptionsByOwnerAndLicenseId[accountId].licenseIds[licenseId];
        return this._capacities.license(license).canDisplayUsage();
      };

      this.canAddSubscriptionToLicenseId = (accountId, licenseId) => {
        if (!licenseId || licenseId == 'null') {
          return false;
        }
        const license = this.subscriptionsByOwnerAndLicenseId[accountId].licenseIds[licenseId];
        return this._capacities.license(license).canAddSubscription();
      };

      this.willSubscriptionRenew = (subscription) =>
        subscription.status === 'Active' && subscription.autoRenew;

      this.willSubscriptionEnd = (subscription) =>
        subscription.status === 'Cancelled' || !subscription.autoRenew;

      this.getProductRatePlan = function (accountId, licenseId) {
        const license = this.subscriptionsByOwnerAndLicenseId[accountId].licenseIds[licenseId];

        const { productRatePlanId, ProductCode__c, ratePlanName } =
          license.subscriptions[0].ratePlans.find(this.showRatePlan);

        const hardcodedRatePlan = this._config.productRatePlans_Enscape.find(
          ({ id }) => id === productRatePlanId,
        );

        if (hardcodedRatePlan) {
          return hardcodedRatePlan;
        }
        return {
          id: productRatePlanId,
          name: ratePlanName,
          term: getPreviewPeriodFromProductCode(ProductCode__c),
        };
      };

      this.toggleCollapse = function (ev) {
        let collapsible;
        if (ev.srcElement) {
          collapsible = ev.srcElement.parentElement.parentElement.nextElementSibling;
        } else {
          collapsible = ev.target.parentElement.parentElement.nextElementSibling;
        }
        if (collapsible.style.maxHeight == '' || collapsible.style.maxHeight == 'auto') {
          collapsible.style.maxHeight = collapsible.scrollHeight + 'px';
        }
        if (collapsible.style.maxHeight == '0px') {
          collapsible.style.maxHeight = collapsible.scrollHeight + 'px';
          setTimeout(function () {
            if (collapsible.style.maxHeight == collapsible.scrollHeight + 'px') {
              collapsible.style.maxHeight = '';
              collapsible.style.overflow = 'visible';
            }
          }, 501);
        } else if (collapsible.style.maxHeight == collapsible.scrollHeight + 'px') {
          collapsible.style.overflow = 'hidden';
          collapsible.style.maxHeight = '0px';
        } else if (
          collapsible.style.maxHeight != collapsible.scrollHeight + 'px' &&
          collapsible.style.maxHeight != '0px'
        ) {
          //needed due to bubbling
          collapsible.style.overflow = 'hidden';
          collapsible.style.maxHeight = '0px';
        }
      };

      AccountService.fetchAccount()
        .then(() => {
          if (!AccountService.getAccount() && !AccountService.isReseller()) {
            $state.go('payment');
            throw 'cancel';
          }
        })
        .then(() => Promise.all([AccountService.getSubscriptions(), ConfigService.getConfig()]))
        .then(([subscriptions, config]) => {
          this._config = config;
          this._capacities = makeCapacities(config);
          subscriptions.sort(function (a, b) {
            if (parseInt(a.accountNumber.substr(1)) > parseInt(b.accountNumber.substr(1))) {
              return 1;
            }
            if (parseInt(a.accountNumber.substr(1)) < parseInt(b.accountNumber.substr(1))) {
              return -1;
            }
            return 0;
          });
          const replaceSubscriptions = [];
          subscriptions.forEach(function (subscription) {
            if (subscription.accountId == AccountService.getAccount().id) {
              if (!AccountService.isReseller()) {
                replaceSubscriptions.unshift(subscription);
              }
            } else {
              replaceSubscriptions.push(subscription);
            }
          });
          subscriptions = replaceSubscriptions;
          subscriptions = subscriptions.map(createMessages);
          this.subscriptions = subscriptions;
          this.subscriptionsByOwner = groupSubscriptionsByOwner(subscriptions);
          this.subscriptionsByOwnerAndLicenseId = groupSubscriptionsByOwnerAndLicenseId(
            this._config,
            this.subscriptionsByOwner,
          );
          this.isLoading = false;
        })
        .catch((e) => {
          if (e !== 'cancel') {
            console.error(e);
          }
        });

      this.usage = function (accountId, licenseId) {
        this.usageSubscription =
          this.subscriptionsByOwnerAndLicenseId[accountId].licenseIds[licenseId].subscriptions[0];
        $state.go('subscription.usage');
      };

      this.supported = true;
      this.showSuccess = false;

      this.success = function () {
        this.showSuccess = true;
        $timeout(() => {
          this.showSuccess = false;
        }, 2000);
      };

      this.fail = function (err) {
        console.error(err);
      };
      this.buy = function (accountId, licenseId) {
        const accountName = this.subscriptionsByOwner[accountId]
          ? this.subscriptionsByOwner[accountId].name
          : '';
        const accountNumber = this.subscriptionsByOwner[accountId]
          ? this.subscriptionsByOwner[accountId].number
          : '';
        const isNewKey = !licenseId;
        const licenseKey = isNewKey
          ? ''
          : getLicenseKeyByLicenseId(this.subscriptionsByOwnerAndLicenseId, licenseId);
        const defaultProductRatePlan = isNewKey
          ? Object.assign({}, this._config.productRatePlan_FloatingLicense)
          : this.getProductRatePlan(accountId, licenseId);
        const availableProductRatePlans = isNewKey
          ? this._config.productRatePlans_Enscape
          : [defaultProductRatePlan];
        const resellerStatus = AccountService.getResellerStatus();
        const subscriptionBuyParams = {
          params: {
            accountId: accountId,
            accountName: accountName,
            accountNumber: accountNumber,
            licenseId: licenseId,
            licenseKey: licenseKey,
            availableProductRatePlans: availableProductRatePlans,
            defaultProductRatePlan: defaultProductRatePlan,
            resellerStatus: resellerStatus,
            isNewKey: isNewKey,
          },
        };
        if (!accountId && !licenseId) {
          subscriptionBuyParams.params.newAccount = true;
          const state = resellerStatus ? 'subscription.order-reseller' : 'subscription.order';

          return $state.go(state, subscriptionBuyParams);
        }

        const state = resellerStatus ? 'subscription.buy-reseller' : 'subscription.buy';
        $state.go(state, subscriptionBuyParams);
      };

      const createMessages = (subscription) => {
        subscription.messages = null;
        if (this.willSubscriptionEnd(subscription)) {
          createCancelMessage(subscription);
        }
        createUpdateMessage(subscription);
        return subscription;
      };

      function createCancelMessage(subscription) {
        if (!subscription.messages) {
          subscription.messages = [];
        }
        subscription.messages.push({
          type: 'cancel',
          values: {
            date: subscription.termEndDate, // TODO tenant specific
          },
        });
      }

      function createUpdateMessage(subscription) {
        subscription.latestRateplans.forEach(function (ratePlan) {
          ratePlan.ratePlanCharges.forEach(function (charge) {
            if (moment(charge.effectiveStartDate).isAfter(moment(), 'day') && charge.quantity > 0) {
              if (!subscription.messages) {
                subscription.messages = [];
              }
              subscription.messages.push({
                type: 'update',
                values: {
                  date: charge.effectiveStartDate,
                  quantity: charge.quantity,
                },
              });
            }
          });
        });
      }
    },
  ]);
}
